import './build/jquery.steps';
import './src/privates'
import {getOptions, getState, paginationClick} from "./src/privates";
import $ from "jquery";

function _goToStep(wizard, options, state, index)
{
    return paginationClick(wizard, options, state, index);
}

$.fn.steps.setStep = function (step)
{

    var options = getOptions(this),
        state = getState(this);

    return _goToStep(this, options, state, step);

};

